import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPauseFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.25 5.097c0-1.02.784-1.847 1.75-1.847s1.75.827 1.75 1.847v13.806c0 1.02-.784 1.847-1.75 1.847s-1.75-.827-1.75-1.847zM15.25 5.097c0-1.02.784-1.847 1.75-1.847s1.75.827 1.75 1.847v13.806c0 1.02-.784 1.847-1.75 1.847s-1.75-.827-1.75-1.847z"
  }));
}
var IcPauseFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPauseFill));

export { IcPauseFill as I };
